var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { direction: "inherit" } },
    [
      _c(
        "div",
        { staticClass: "pure-g", style: _vm.style },
        [_vm._t("default")],
        2
      ),
      _vm.debug
        ? _c("Overlay", {
            attrs: { cols: _vm.actualNumCols, gutterWidth: _vm.windowGutter },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }